import React, { useState } from 'react';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

function App() {
  const [notes, setNotes] = useState([]);
  const [input, setInput] = useState('');
  const [showInput, setShowInput] = useState(false);
  const colors = ['#FEEC37', '#ff3de8', '#4CC9FE', '#7ED4AD', '#bc83e6', '#E1ACAC'];
  const [colorIndex, setColorIndex] = useState(0);

  const handleCreateClick = () => setShowInput(true);

  const handleInputChange = (e) => setInput(e.target.value);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && input.trim()) {
      addNote();
    }
  };

  const addNote = () => {
    setNotes([...notes, { text: input, color: colors[colorIndex] }]);
    setInput('');
    setShowInput(false);
    setColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
  };

  const deleteNote = (index) => {
    setNotes(notes.filter((_, i) => i !== index));
  };

  return (
    
    <div className="container">
      <div className='heading'>
          <h1>Sticky Notes</h1>
      </div>
      <div className="notes">
        <div id="create" onClick={handleCreateClick}>
          {!showInput ? (
            <FontAwesomeIcon icon={faPlus} />
          ) : (
            <div className="createBox">
              <div className="innerCreateBox">
                <textarea
                  id="userInput"
                  maxLength="160"
                  placeholder="Write Here. . ."
                  value={input}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
              </div>
            </div>
          )}
        </div>
        {notes.map((note, index) => (
          <div
            key={index}
            className="note"
            style={{ backgroundColor: note.color }}
            onDoubleClick={() => deleteNote(index)}
          >
            <div className="details">
              <h3>{note.text}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;
